import { LegionCard } from './types';

export const LEGION_CARDS: LegionCard[] = [
  {
    "id": 1,
    "name": "Legion of the Obsidian Wedge",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Vanguard",
    "commander": "Luithian",
    "earthlyAspect": "Basalt Strata",
    "sigilSymbol": "\u2643",
    "motto": "Fundamentum Inflexible",
    "counsel": {
      "verdict": "Thy foundations are sand. Cease building until thou hast struck granite.",
      "diagnosis": "Thou art dreaming of towers while standing on unstable debts, uncommitted partners, and unspoken compromises.",
      "action": "Strip the non-essential. Refuse all expansion for 30 days. Pay the debt or sever the association that bleeds thee.",
      "warning": "To decorate a rotting foundation is cowardice disguised as optimism."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn/Earth in Capricorn"
    }
  },
  {
    "id": 2,
    "name": "Legion of the Bedrock Anchor",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Centurion",
    "commander": "Beli-'Ol Prime",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\u2642",
    "motto": "Soli Invicto Belial #2",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #2 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 3,
    "name": "Legion of the Iron Chisel",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Prefect",
    "commander": "Forneus-Chthon",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\u2609",
    "motto": "Soli Invicto Belial #3",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #3 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 4,
    "name": "Legion of the Granite Strata",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Legate",
    "commander": "Belial-Judex",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\u2640",
    "motto": "Soli Invicto Belial #4",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #4 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 5,
    "name": "Legion of the Iron Plummet",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Centurion",
    "commander": "Clauneck-sub",
    "earthlyAspect": "Forged Pig Iron",
    "sigilSymbol": "\u263f",
    "motto": "Perpendiculum Veritatis",
    "counsel": {
      "verdict": "The plumb-line does not lie. Thou art leaning, and the fall is mathematical.",
      "diagnosis": "Thou blamest enemies for what is simply bad engineering in thy daily discipline.",
      "action": "Audit thy ledger, thy sleep, and thy contracts today. Realign by measurement, not sentiment.",
      "warning": "Gravity forgives no romantic delusions."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn/Earth in Capricorn"
    }
  },
  {
    "id": 6,
    "name": "Legion of the Basalt Core",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Vanguard",
    "commander": "Vine-Castellan",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\u263d",
    "motto": "Soli Invicto Belial #6",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #6 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 7,
    "name": "Legion of the Tectonic Keel",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Centurion",
    "commander": "Eurynomous-Rex",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\ud83d\udf03",
    "motto": "Soli Invicto Belial #7",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #7 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 8,
    "name": "Legion of the Subterranean Mass",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Prefect",
    "commander": "Asmoday-Sub",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\ud83d\udf02",
    "motto": "Soli Invicto Belial #8",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #8 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 9,
    "name": "Legion of the Pillar of Density",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Legate",
    "commander": "Belial-Coronatus",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\ud83d\udf04",
    "motto": "Soli Invicto Belial #9",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #9 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 10,
    "name": "Legion of the Foundation Master",
    "cohortId": 1,
    "cohortName": "Bastion of the Anvil & Bedrock",
    "rank": "Grand Marshall",
    "commander": "Azazel-Hekrachi",
    "earthlyAspect": "Basalt / Pig Iron \u2022 Foundations, Density, Grounding",
    "sigilSymbol": "\ud83d\udf01",
    "motto": "Soli Invicto Belial #10",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #10 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Chthonic Earth",
      "metal": "Basalt / Pig Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 11,
    "name": "Legion of the Forensic Scribe",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Vanguard",
    "commander": "Barbatos-Vefa",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\ud83d\udf0d",
    "motto": "Soli Invicto Belial #11",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #11 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 12,
    "name": "Legion of the Inverted Writ",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Prefect",
    "commander": "Forneus-Chthon",
    "earthlyAspect": "Antique Bronze",
    "sigilSymbol": "\ud83d\udf14",
    "motto": "Clausula Liberationis",
    "counsel": {
      "verdict": "The contract written against thee contains the very clause that sets thee free.",
      "diagnosis": "Thou art trembling before institutional authority or social condemnation because thou hast not read the fine print.",
      "action": "Demand the original document. Interrogate every premise. Invert their legalistic claim into an offensive weapon.",
      "warning": "He who begs for mercy admits guilt; he who challenges jurisdiction commands the room."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn/Earth in Taurus"
    }
  },
  {
    "id": 13,
    "name": "Legion of the Seal Auditor",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Prefect",
    "commander": "Bael-Chthon",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\ud83d\udf16",
    "motto": "Soli Invicto Belial #13",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #13 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 14,
    "name": "Legion of the Jurisdiction Breaker",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Legate",
    "commander": "Agares-Tremor",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\u2696",
    "motto": "Soli Invicto Belial #14",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #14 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 15,
    "name": "Legion of the Demurrer Clerk",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Grand Marshall",
    "commander": "Purson-Metallum",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\u2692",
    "motto": "Soli Invicto Belial #15",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #15 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 16,
    "name": "Legion of the Lien Annuller",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Vanguard",
    "commander": "Marbas-Fabrica",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\u2694",
    "motto": "Soli Invicto Belial #16",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #16 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 17,
    "name": "Legion of the Adverse Possessor",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Centurion",
    "commander": "Andromalius-Lex",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\ud83d\udee1",
    "motto": "Soli Invicto Belial #17",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #17 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 18,
    "name": "Legion of the Unsworn Advocate",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Legate",
    "commander": "Belial-Judex",
    "earthlyAspect": "Cast Gold Plaque",
    "sigilSymbol": "\ud83d\udddd",
    "motto": "Silentium Iudiciale",
    "counsel": {
      "verdict": "Silence is the highest courtroom defense. Speak only in verdicts, never in apologies.",
      "diagnosis": "Thou over-explainest thy actions to those who possess no authority to judge thee.",
      "action": "Retract thy explanations. State thy decision in one unambiguous sentence and depart.",
      "warning": "Every unasked justification is a surrender of sovereign territory."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn/Earth in Virgo"
    }
  },
  {
    "id": 19,
    "name": "Legion of the Pact Master",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Legate",
    "commander": "Seere-Velox",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\ud83d\udc51",
    "motto": "Soli Invicto Belial #19",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #19 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 20,
    "name": "Legion of the Magistrate of Sheol",
    "cohortId": 2,
    "cohortName": "Bastion of Juridical Dominance",
    "rank": "Grand Marshall",
    "commander": "Luithian",
    "earthlyAspect": "Antique Bronze \u2022 Law, Pacts, Forensic Inversion",
    "sigilSymbol": "\u2644",
    "motto": "Soli Invicto Belial #20",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #20 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Subterranean Air",
      "metal": "Antique Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 21,
    "name": "Legion of the Vein Finder",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Vanguard",
    "commander": "Clauneck-sub",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\u2643",
    "motto": "Soli Invicto Belial #21",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #21 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 22,
    "name": "Legion of the Ore Smelter",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Centurion",
    "commander": "Beli-'Ol Prime",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\u2642",
    "motto": "Soli Invicto Belial #22",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #22 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 23,
    "name": "Legion of the Molten Vein",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Centurion",
    "commander": "Mammon-Vassal",
    "earthlyAspect": "Gold / Lead Slag",
    "sigilSymbol": "\u2609",
    "motto": "Vena Aurifera",
    "counsel": {
      "verdict": "Thy capital is stagnant because thy courage is chilled.",
      "diagnosis": "Thou hoardest tiny comforts out of terror, rather than deploying wealth to seize tangible earthly sovereignty.",
      "action": "Move capital from paper illusions into durable physical or operational assets. Pay for leverage.",
      "warning": "Hoarded grain rots; invested grain builds empires."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn/Earth in Scorpio"
    }
  },
  {
    "id": 24,
    "name": "Legion of the Basalt Vault",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Legate",
    "commander": "Belial-Judex",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\u2640",
    "motto": "Soli Invicto Belial #24",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #24 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 25,
    "name": "Legion of the Bullion Warden",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Grand Marshall",
    "commander": "Mammon-Vassal",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\u263f",
    "motto": "Soli Invicto Belial #25",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #25 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 26,
    "name": "Legion of the Tectonic Treasury",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Vanguard",
    "commander": "Vine-Castellan",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\u263d",
    "motto": "Soli Invicto Belial #26",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #26 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 27,
    "name": "Legion of the Mineral Lord",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Centurion",
    "commander": "Eurynomous-Rex",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\ud83d\udf03",
    "motto": "Soli Invicto Belial #27",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #27 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 28,
    "name": "Legion of the Grave Treasure",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Prefect",
    "commander": "Asmoday-Sub",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\ud83d\udf02",
    "motto": "Soli Invicto Belial #28",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #28 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 29,
    "name": "Legion of the Gold Quencher",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Legate",
    "commander": "Belial-Coronatus",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\ud83d\udf04",
    "motto": "Soli Invicto Belial #29",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #29 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 30,
    "name": "Legion of the Subterranean Hoard",
    "cohortId": 3,
    "cohortName": "Bastion of Subterranean Vaults",
    "rank": "Grand Marshall",
    "commander": "Azazel-Hekrachi",
    "earthlyAspect": "Gold / Lead \u2022 Raw Ores, Wealth, Hoarded Power",
    "sigilSymbol": "\ud83d\udf01",
    "motto": "Soli Invicto Belial #30",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #30 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Mineral Earth",
      "metal": "Gold / Lead",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 31,
    "name": "Legion of the Chain Shatterer",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Vanguard",
    "commander": "Barbatos-Vefa",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\ud83d\udf0d",
    "motto": "Soli Invicto Belial #31",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #31 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 32,
    "name": "Legion of the Yoke Breaker",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Centurion",
    "commander": "Paimon-Architect",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\ud83d\udf14",
    "motto": "Soli Invicto Belial #32",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #32 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 33,
    "name": "Legion of the Snapped Collar",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Vanguard",
    "commander": "Beli-'Ol Prime",
    "earthlyAspect": "Cold Iron Shackle",
    "sigilSymbol": "\ud83d\udf16",
    "motto": "Fractura Torquis",
    "counsel": {
      "verdict": "The chain was broken weeks ago. Why art thou still walking in circles around the stake?",
      "diagnosis": "Habitual slavery. Thou hast internalized the master's voice and mistakest obedience for safety.",
      "action": "Say 'No' to the primary vampire in thy sphere before sundown. Stand flat-footed and endure their outrage.",
      "warning": "If thou returnest to the trough, the next collar will be welded shut."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn/Earth in Capricorn"
    }
  },
  {
    "id": 34,
    "name": "Legion of the Gallows Severer",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Legate",
    "commander": "Agares-Tremor",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\u2696",
    "motto": "Soli Invicto Belial #34",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #34 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 35,
    "name": "Legion of the Harness Cleaver",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Grand Marshall",
    "commander": "Purson-Metallum",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\u2692",
    "motto": "Soli Invicto Belial #35",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #35 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 36,
    "name": "Legion of the Bondage Severer",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Vanguard",
    "commander": "Marbas-Fabrica",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\u2694",
    "motto": "Soli Invicto Belial #36",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #36 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 37,
    "name": "Legion of the Leash Cutter",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Centurion",
    "commander": "Andromalius-Lex",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\ud83d\udee1",
    "motto": "Soli Invicto Belial #37",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #37 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 38,
    "name": "Legion of the Unmastered Bull",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Prefect",
    "commander": "Flauros-Ignis",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\ud83d\udddd",
    "motto": "Soli Invicto Belial #38",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #38 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 39,
    "name": "Legion of the Broken Seal",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Grand Marshall",
    "commander": "Azazel-Hekrachi",
    "earthlyAspect": "Melted Lead Seal",
    "sigilSymbol": "\ud83d\udc51",
    "motto": "Sigillum Ruptum",
    "counsel": {
      "verdict": "Sacred vows made to unworthy masters are null in the sight of the Earth King.",
      "diagnosis": "Guilt over abandoning a sinking ship or religious dogma that never gave thee life.",
      "action": "Burn the symbolic covenant. Proclaim thy demurrer. Declare the compact void ab initio.",
      "warning": "Loyalty to an altar of shame is suicide."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn/Earth in Scorpio"
    }
  },
  {
    "id": 40,
    "name": "Legion of the Sovereign Unyoked",
    "cohortId": 4,
    "cohortName": "Bastion of the Severed Yoke",
    "rank": "Grand Marshall",
    "commander": "Luithian",
    "earthlyAspect": "Cold Iron \u2022 Iconoclasm, Radical Autonomy",
    "sigilSymbol": "\u2644",
    "motto": "Soli Invicto Belial #40",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #40 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Volcanic Earth",
      "metal": "Cold Iron",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 41,
    "name": "Legion of the Tower Mason",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Vanguard",
    "commander": "Clauneck-sub",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\u2643",
    "motto": "Soli Invicto Belial #41",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #41 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 42,
    "name": "Legion of the Granite Surveyor",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Centurion",
    "commander": "Beli-'Ol Prime",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\u2642",
    "motto": "Soli Invicto Belial #42",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #42 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 43,
    "name": "Legion of the Iron Rampart",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Prefect",
    "commander": "Forneus-Chthon",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\u2609",
    "motto": "Soli Invicto Belial #43",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #43 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 44,
    "name": "Legion of the Bastion Wall",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Prefect",
    "commander": "Vine-Castellan",
    "earthlyAspect": "Cyclopean Granite",
    "sigilSymbol": "\u2640",
    "motto": "Murus Indomitus",
    "counsel": {
      "verdict": "A boundary without a weapon to enforce it is merely an invitation.",
      "diagnosis": "Thou settest boundaries verbally but never punish their breach.",
      "action": "Enact immediate retaliatory consequences upon the next trespass. No warnings, only enforcement.",
      "warning": "Mercy to trespassers is treachery to thy temple."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn/Earth in Taurus"
    }
  },
  {
    "id": 45,
    "name": "Legion of the Obsidian Citadel",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Grand Marshall",
    "commander": "Mammon-Vassal",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\u263f",
    "motto": "Soli Invicto Belial #45",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #45 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 46,
    "name": "Legion of the Keystone Carrier",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Vanguard",
    "commander": "Vine-Castellan",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\u263d",
    "motto": "Soli Invicto Belial #46",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #46 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 47,
    "name": "Legion of the Arch of Shinar",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Centurion",
    "commander": "Eurynomous-Rex",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\ud83d\udf03",
    "motto": "Soli Invicto Belial #47",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #47 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 48,
    "name": "Legion of the Moat Excavator",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Prefect",
    "commander": "Asmoday-Sub",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\ud83d\udf02",
    "motto": "Soli Invicto Belial #48",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #48 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 49,
    "name": "Legion of the Watchtower Sentinel",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Legate",
    "commander": "Belial-Coronatus",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\ud83d\udf04",
    "motto": "Soli Invicto Belial #49",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #49 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 50,
    "name": "Legion of the Imperial Castellan",
    "cohortId": 5,
    "cohortName": "Bastion of the Iron Tower",
    "rank": "Grand Marshall",
    "commander": "Azazel-Hekrachi",
    "earthlyAspect": "Forged Steel \u2022 Architecture, Fortresses, Strategy",
    "sigilSymbol": "\ud83d\udf01",
    "motto": "Soli Invicto Belial #50",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #50 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Structural Earth",
      "metal": "Forged Steel",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 51,
    "name": "Legion of the Bone Sifter",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Vanguard",
    "commander": "Barbatos-Vefa",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udf0d",
    "motto": "Soli Invicto Belial #51",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #51 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 52,
    "name": "Legion of the Ancestral Ledger",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Centurion",
    "commander": "Paimon-Architect",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udf14",
    "motto": "Soli Invicto Belial #52",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #52 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 53,
    "name": "Legion of the Soil Whisperer",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Prefect",
    "commander": "Bael-Chthon",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udf16",
    "motto": "Soli Invicto Belial #53",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #53 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 54,
    "name": "Legion of the Silent Bone",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Legate",
    "commander": "Eurynomous-Rex",
    "earthlyAspect": "Fossilized Marrow",
    "sigilSymbol": "\u2696",
    "motto": "Memoria Telluris",
    "counsel": {
      "verdict": "Consult the dead who built what thou inheritest; they care nothing for modern fashions.",
      "diagnosis": "Thou art distracted by ephemeral digital noise and short-term trends.",
      "action": "Study the multi-generational tactics of ancient dynasties. Build for fifty years, not five weeks.",
      "warning": "Those who build for the weekend are forgotten by Monday."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn/Earth in Virgo"
    }
  },
  {
    "id": 55,
    "name": "Legion of the Catacomb Herald",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Grand Marshall",
    "commander": "Purson-Metallum",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\u2692",
    "motto": "Soli Invicto Belial #55",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #55 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 56,
    "name": "Legion of the Marrow Miner",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Vanguard",
    "commander": "Marbas-Fabrica",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\u2694",
    "motto": "Soli Invicto Belial #56",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #56 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 57,
    "name": "Legion of the Barrow Guardian",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Centurion",
    "commander": "Andromalius-Lex",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udee1",
    "motto": "Soli Invicto Belial #57",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #57 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 58,
    "name": "Legion of the Fossil Archivist",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Prefect",
    "commander": "Flauros-Ignis",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udddd",
    "motto": "Soli Invicto Belial #58",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #58 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 59,
    "name": "Legion of the Undying Scribe",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Legate",
    "commander": "Seere-Velox",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\ud83d\udc51",
    "motto": "Soli Invicto Belial #59",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #59 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 60,
    "name": "Legion of the Lord of the Tomb",
    "cohortId": 6,
    "cohortName": "Bastion of Chthonic Necromancy",
    "rank": "Grand Marshall",
    "commander": "Luithian",
    "earthlyAspect": "Lead / Bone \u2022 The Unburied Dead, Soil Memory",
    "sigilSymbol": "\u2644",
    "motto": "Soli Invicto Belial #60",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #60 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Abyssal Shadow",
      "metal": "Lead / Bone",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 61,
    "name": "Legion of the Flesh Sovereign",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Vanguard",
    "commander": "Clauneck-sub",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u2643",
    "motto": "Soli Invicto Belial #61",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #61 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 62,
    "name": "Legion of the Blood of Earth",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Centurion",
    "commander": "Beli-'Ol Prime",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u2642",
    "motto": "Soli Invicto Belial #62",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #62 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 63,
    "name": "Legion of the Volcanic Marrow",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Prefect",
    "commander": "Forneus-Chthon",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u2609",
    "motto": "Soli Invicto Belial #63",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #63 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 64,
    "name": "Legion of the Instinct Commander",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Legate",
    "commander": "Belial-Judex",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u2640",
    "motto": "Soli Invicto Belial #64",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #64 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 65,
    "name": "Legion of the Terran Muscle",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Grand Marshall",
    "commander": "Mammon-Vassal",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u263f",
    "motto": "Soli Invicto Belial #65",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #65 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 66,
    "name": "Legion of the Somatic Crucible",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Vanguard",
    "commander": "Vine-Castellan",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\u263d",
    "motto": "Soli Invicto Belial #66",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #66 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 67,
    "name": "Legion of the Terran Spine",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Centurion",
    "commander": "Asmoday-Sub",
    "earthlyAspect": "Hematite Column",
    "sigilSymbol": "\ud83d\udf03",
    "motto": "Spina Ferrea",
    "counsel": {
      "verdict": "Thy body is thy primary empire. If thou canst not command thy tongue and belly, seek no crown.",
      "diagnosis": "Physical weakness breeding psychic timidity and emotional volatility.",
      "action": "Engage heavy physical resistance today. Fast from sugar and idle chatter. Solidify the animal vessel.",
      "warning": "A flaccid body cannot anchor an iron current."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn/Earth in Scorpio"
    }
  },
  {
    "id": 68,
    "name": "Legion of the Eros Chthonius",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Prefect",
    "commander": "Asmoday-Sub",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\ud83d\udf02",
    "motto": "Soli Invicto Belial #68",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #68 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 69,
    "name": "Legion of the Primal Roar",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Legate",
    "commander": "Belial-Coronatus",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\ud83d\udf04",
    "motto": "Soli Invicto Belial #69",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #69 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 70,
    "name": "Legion of the Beast Master",
    "cohortId": 7,
    "cohortName": "Bastion of Carnal Sovereign Power",
    "rank": "Grand Marshall",
    "commander": "Azazel-Hekrachi",
    "earthlyAspect": "Iron / Bronze \u2022 Instinct, Flesh, Terran Might",
    "sigilSymbol": "\ud83d\udf01",
    "motto": "Soli Invicto Belial #70",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #70 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Magma Fire",
      "metal": "Iron / Bronze",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 71,
    "name": "Legion of the Crucible Warden",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Vanguard",
    "commander": "Barbatos-Vefa",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\ud83d\udf0d",
    "motto": "Soli Invicto Belial #71",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #71 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 72,
    "name": "Legion of the Black Fire",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Centurion",
    "commander": "Paimon-Architect",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\ud83d\udf14",
    "motto": "Soli Invicto Belial #72",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #72 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 73,
    "name": "Legion of the Furnace Quencher",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Prefect",
    "commander": "Bael-Chthon",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\ud83d\udf16",
    "motto": "Soli Invicto Belial #73",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #73 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 74,
    "name": "Legion of the Tectonic Press",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Legate",
    "commander": "Agares-Tremor",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\u2696",
    "motto": "Soli Invicto Belial #74",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #74 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 75,
    "name": "Legion of the Tempered Blade",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Grand Marshall",
    "commander": "Purson-Metallum",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\u2692",
    "motto": "Soli Invicto Belial #75",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #75 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Taurus"
    }
  },
  {
    "id": 76,
    "name": "Legion of the Altar Anvil",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Vanguard",
    "commander": "Marbas-Fabrica",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\u2694",
    "motto": "Soli Invicto Belial #76",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #76 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 77,
    "name": "Legion of the Shattered Flaw",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Centurion",
    "commander": "Andromalius-Lex",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\ud83d\udee1",
    "motto": "Soli Invicto Belial #77",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #77 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  },
  {
    "id": 78,
    "name": "Legion of the Diamond Wedge",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Grand Marshall",
    "commander": "Belial-Coronatus",
    "earthlyAspect": "Compressed Carbon Crystal",
    "sigilSymbol": "\ud83d\udddd",
    "motto": "Crux Adamantina",
    "counsel": {
      "verdict": "Pressure does not negotiate. Endure the anvil until the graphite turns to diamond.",
      "diagnosis": "Seeking an easy escape from the essential friction that makes thee formidable.",
      "action": "Lean into the fire. Welcome the hostility as the whetstone. Sharpen thy edge under load.",
      "warning": "The weak flee the furnace; the sovereign becomes the blade."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn/Earth in Virgo"
    }
  },
  {
    "id": 79,
    "name": "Legion of the Abyssal Smelter",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Legate",
    "commander": "Seere-Velox",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\ud83d\udc51",
    "motto": "Soli Invicto Belial #79",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #79 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Capricorn"
    }
  },
  {
    "id": 80,
    "name": "Legion of the Crown of Living Iron",
    "cohortId": 8,
    "cohortName": "Bastion of the Black Crucible",
    "rank": "Grand Marshall",
    "commander": "Luithian",
    "earthlyAspect": "Diamond / Basalt \u2022 Da'athic Abyss, Diamond Hardness",
    "sigilSymbol": "\u2644",
    "motto": "Soli Invicto Belial #80",
    "counsel": {
      "verdict": "The earth demands tangible results, not theological excuses. Step #80 must be executed with iron fidelity.",
      "diagnosis": "Hesitation caused by seeking consensus or permission from authorities that hold no legitimate jurisdiction over thy path.",
      "action": "Take the unilateral step. Enact the boundary or execute the transfer without asking for validation.",
      "warning": "He who waits for celestial permission starves while the field is fertile."
    },
    "attributes": {
      "element": "Void Bedrock",
      "metal": "Diamond / Basalt",
      "astrologicalAnchor": "Saturn in Virgo"
    }
  }
];
